/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RecalculateDutyScheduleRequest
 */
export interface RecalculateDutyScheduleRequest {
    /**
     * 
     * @type {string}
     * @memberof RecalculateDutyScheduleRequest
     */
    name: string;
    /**
     * 
     * @type {Date}
     * @memberof RecalculateDutyScheduleRequest
     */
    periodStart: Date;
    /**
     * 
     * @type {Date}
     * @memberof RecalculateDutyScheduleRequest
     */
    periodEnd: Date;
}

/**
 * Check if a given object implements the RecalculateDutyScheduleRequest interface.
 */
export function instanceOfRecalculateDutyScheduleRequest(value: object): value is RecalculateDutyScheduleRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('periodStart' in value) || value['periodStart'] === undefined) return false;
    if (!('periodEnd' in value) || value['periodEnd'] === undefined) return false;
    return true;
}

export function RecalculateDutyScheduleRequestFromJSON(json: any): RecalculateDutyScheduleRequest {
    return RecalculateDutyScheduleRequestFromJSONTyped(json, false);
}

export function RecalculateDutyScheduleRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecalculateDutyScheduleRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'periodStart': (new Date(json['periodStart'])),
        'periodEnd': (new Date(json['periodEnd'])),
    };
}

export function RecalculateDutyScheduleRequestToJSON(json: any): RecalculateDutyScheduleRequest {
    return RecalculateDutyScheduleRequestToJSONTyped(json, false);
}

export function RecalculateDutyScheduleRequestToJSONTyped(value?: RecalculateDutyScheduleRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'periodStart': `${value['periodStart'].getFullYear()}-${String(value['periodStart'].getMonth()+1).padStart(2,'0')}-${String(value['periodStart'].getDate()).padStart(2,'0')}`,
        'periodEnd': `${value['periodEnd'].getFullYear()}-${String(value['periodEnd'].getMonth()+1).padStart(2,'0')}-${String(value['periodEnd'].getDate()).padStart(2,'0')}`,
    };
}

